export default "https://assets-v2.scaler.com/packs/images/HackerRank.ef726e.svg";